import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'

import {
  _GoogleAdWords,
  Settings
} from '../namespace-helper'

export default {
  namespaced: true,
  state: {
    uploadSuccess: false
  },
  mutations: {

  },
  actions: {
    [_GoogleAdWords.actions.getSuggestionsForProduct] (context, payload) {
      const url = API_URL + '/api/v1/getAdWordsSuggestions'
      store.commit(Settings.mutations.setLoading, true)
      return axios.post(url, {
        params: payload
      }, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_GoogleAdWords.mutations.uploadProductState, r)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    }
  },
  getters: {
    [_GoogleAdWords.getters.getServerResponse] (state) {
      return state.uploadSuccess
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/GoogleAdword/googleAdWords.js